import React from 'react';
//  { useMemo }
import { useLanguage } from '../../locale/useLanguage';
import {
  // PremiseType,
  WeekDay,
} from '../../models';
import { HourOption, HourSelector } from '../HourSelector/HourSelector';
// import {
//   RadioButtonGroup,
//   RadioButtonGroupOption,
// } from '../RadioButtonGroup/RadioButtonGroup';
import { WeekDayPicker } from '../WeekDayPicker/WeekDayPicker';

import './ConciergeForm.css';
import { useOrder } from '../../hooks/useOrder';
import dayjs from 'dayjs';

let morningHourOptions_: HourOption[] = [6, 7, 8, 9, 10, 11, 12, 13].map(
  (hour) => ({
    value: hour.toFixed(0).padStart(2, '0'),
    label: hour.toFixed(0).padStart(2, '0'),
  })
);

let afternoonHourOptions_: HourOption[] = [
  14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
].map((hour) => ({
  value: hour.toFixed(0).padStart(2, '0'),
  label: hour.toFixed(0).padStart(2, '0'),
}));

type ConciergeFormProps = {
  // premiseTypeFieldValue?: PremiseType;
  // onPremiseTypeChange: (val: PremiseType) => void;
  selectedWeekDays?: WeekDay[];
  onWeekDaysChange?: (weekDay: WeekDay) => void;
  daysFieldError?: string;
  conciergeMorningFromHour: string;
  conciergeMorningToHour: string;
  conciergeAfternoonFromHour: string;
  conciergeAfternoonToHour: string;
  conciergeMorningFromHourChange: (option: string | undefined) => void;
  conciergeMorningToHourChange: (option: string | undefined) => void;
  conciergeAfternoonFromHourChange: (option: string | undefined) => void;
  conciergeAfternoonToHourChange: (option: string | undefined) => void;
  conciergeOpeningHoursError?: string;
  isOrderSpecific?: boolean;
};

export const ConciergeForm: React.FC<ConciergeFormProps> = ({
  // premiseTypeFieldValue,
  // onPremiseTypeChange,
  selectedWeekDays,
  onWeekDaysChange,
  daysFieldError,
  conciergeMorningFromHour,
  conciergeMorningToHour,
  conciergeAfternoonFromHour,
  conciergeAfternoonToHour,
  conciergeMorningFromHourChange,
  conciergeMorningToHourChange,
  conciergeAfternoonFromHourChange,
  conciergeAfternoonToHourChange,
  conciergeOpeningHoursError,
  isOrderSpecific = true,
}) => {
  const [t] = useLanguage();
  const order = useOrder();
  let morningHourOptions = morningHourOptions_;
  let afternoonHourOptions = afternoonHourOptions_;
  if (isOrderSpecific) {
    if (order?.receptionRules?.startReceptionTime) {
      const startReceptionTime = dayjs(
        order!.receptionRules!.startReceptionTime,
        'HH:mm'
      );
      morningHourOptions = morningHourOptions_.filter((hour) =>
        dayjs({ hour: parseInt(hour.value, 10) }).isSameOrAfter(
          startReceptionTime
        )
      );
    }
    if (order?.receptionRules?.endReceptionTime) {
      const endReceptionTime = dayjs(
        order!.receptionRules!.endReceptionTime,
        'HH:mm'
      );
      afternoonHourOptions = afternoonHourOptions_.filter((hour) =>
        dayjs({ hour: parseInt(hour.value, 10) }).isSameOrBefore(
          endReceptionTime
        )
      );
    }
  }
  // const premiseTypeOptions: RadioButtonGroupOption<PremiseType>[] = useMemo(
  //   () => [
  //     {
  //       label: t('addressNotesView.reception'),
  //       value: PremiseType.Reception,
  //     },
  //     {
  //       label: t('addressNotesView.office'),
  //       value: PremiseType.Office,
  //     },
  //     {
  //       label: t('addressNotesView.store'),
  //       value: PremiseType.Store,
  //     },
  //   ],
  //   [t]
  // );

  const weekdayMap: { [index: string]: WeekDay } = {
    '1': WeekDay.Mon,
    '2': WeekDay.Tue,
    '3': WeekDay.Wed,
    '4': WeekDay.Thu,
    '5': WeekDay.Fri,
    '6': WeekDay.Sat,
    '7': WeekDay.Sun,
  };

  return (
    <>
      {/* <div className="concierge-form--field-container">
        <label className="concierge-form--label-style concierge-form--label-container">
          {t('addressNotesView.addressType')}
        </label>
        <RadioButtonGroup
          options={premiseTypeOptions}
          selectedValue={premiseTypeFieldValue}
          onChangeValue={onPremiseTypeChange}
        />
      </div> */}
      <div className="concierge-form--days-container">
        <p className="concierge-form--label-style">
          {t('addressNotesView.selectDays')}
        </p>
        <WeekDayPicker
          onDayClicked={onWeekDaysChange}
          selectedDays={selectedWeekDays}
          disabledDays={
            order?.receptionRules?.availableWeekDays
              ? [1, 2, 3, 4, 5, 6, 7]
                  .filter(
                    (index) =>
                      !order?.receptionRules?.availableWeekDays.includes(index)
                  )
                  .map((index) => weekdayMap[index])
              : []
          }
        />
        {daysFieldError && <p className="error-message">{daysFieldError}</p>}
      </div>
      <div className="concierge-form--hour-container">
        <div className="concierge-form--time-slot-line">
          <div className="concierge-form--morning-col concierge-form--col-title">
            <div className="concierge-form--col-description concierge-form--time-description-container concierge-form--label-style">
              {t('addressNotesView.selectHours')}
            </div>
            <div className="concierge-form--time-slot-container">
              <p className="subtitle concierge-form--time-slot">
                {t('addressNotesView.morning')}
              </p>
            </div>
          </div>
          <div className="concierge-form--morning-col">
            <div className="concierge-form--time-description-container concierge-form--label-style">
              {t('addressNotesView.fromTime')}
            </div>
            <HourSelector
              onChange={conciergeMorningFromHourChange}
              value={conciergeMorningFromHour}
              options={morningHourOptions}
            />
          </div>
          <div className="concierge-form--morning-col">
            <div className="concierge-form--time-description-container concierge-form--label-style">
              {t('addressNotesView.toTime')}
            </div>
            <HourSelector
              onChange={conciergeMorningToHourChange}
              value={conciergeMorningToHour}
              options={morningHourOptions}
            />
          </div>
        </div>
        <div className="concierge-form--time-slot-line">
          <div className="concierge-form--col-title">
            <p className="subtitle concierge-form--time-slot">
              {t('addressNotesView.afternoon')}
            </p>
          </div>
          <div className="concierge-form--slot-col-container">
            <HourSelector
              options={afternoonHourOptions}
              onChange={conciergeAfternoonFromHourChange}
              value={conciergeAfternoonFromHour}
            />
          </div>
          <div className="concierge-form--slot-col-container">
            <HourSelector
              options={afternoonHourOptions}
              onChange={conciergeAfternoonToHourChange}
              value={conciergeAfternoonToHour}
            />
          </div>
        </div>
        {conciergeOpeningHoursError && (
          <p className="error-message">{conciergeOpeningHoursError}</p>
        )}
      </div>
    </>
  );
};
